<template>
  <v-container>
    <v-row>
      <v-col cols="4" v-for="(group, groupName) in groups" :key="groupName">
        <v-card max-width="300" class="mx-auto">
          <v-toolbar color="cyan" dark dense>
            <v-toolbar-title>{{ groupName }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog persistent v-model="personDialog[groupName]" @keydown.esc="closePersonDialog(groupName, false)"
                      max-width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-on="on" v-bind="attrs">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <person-editor :group-id="groupName" @closePersonDialog="closePersonDialog" :dialog-name="groupName"/>
            </v-dialog>

          </v-toolbar>
          <v-list three-line>
            <template v-for="(storeGroups, userName) in group">
              <v-dialog :key="userName" persistent v-model="personDialog[userName]"
                        @keydown.esc="closePersonDialog(userName, false)" max-width="500">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item>
                    <v-list-item-avatar v-on="on" v-bind="attrs">
                      <v-img src="https://cdn.vuetifyjs.com/images/logos/logo.svg"></v-img>
                    </v-list-item-avatar>

                    <v-list-item-content>
                      <v-list-item-title v-on="on" v-bind="attrs">{{ userName }}</v-list-item-title>
                      <v-expansion-panels accordion flat multiple>
                        <v-expansion-panel v-for="(stores, i) in storeGroups" :key="i">
                          <v-expansion-panel-header>
                            <v-list-item-subtitle>{{ stores.name }}</v-list-item-subtitle>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-list-item-subtitle v-for="(storeName, j) in stores.value" :key="j">
                              {{ storeName }}
                            </v-list-item-subtitle>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider/>
                </template>
                <person-editor :name="userName" :group-id="groupName" :dialog-name="userName"
                               @closePersonDialog="closePersonDialog"/>
              </v-dialog>
            </template>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PersonEditor from "@/page/Group/PersonEditor";

export default {
  name: "Groups",
  components: {PersonEditor},
  data: () => ({
    groups: [],
    personDialog: {},
    stores: {},
  }),
  methods: {
    getData() {
      this.groups = null;
      this.stores = {};
      this.$axios.get("/stores/all").then(
          response => {
            // 获得分组完毕的所有店铺信息
            this.stores = this.formatStores(response.data);

            this.$axios.get("/groups").then(
                response => {
                  this.groups = response.data;
                  // 将每个用户下的店铺, 按地区进行分组
                  for (let groupName in this.groups) {
                    let group = this.groups[groupName];
                    for (let userName in group) {
                      this.$set(group, userName, this.formatStores(group[userName], this.stores));
                    }
                  }
                }
            )
          }
      );

    },
    closePersonDialog(itemId, isRefresh) {
      this.personDialog[itemId] = false;

      if (isRefresh) {
        this.getData();
      }
    },
    /**
     * 将所有店铺按后缀进行分组
     * @param stores
     * @param compare
     * @returns {{}|[]}
     */
    formatStores(stores, compare) {
      let formatted = {};
      for (let store of stores) {
        let prefix;
        if (store.split("-").length > 1) {
          prefix = store.split("-")[1];
        } else {
          prefix = "其他";
        }

        if (formatted && formatted[prefix]) {
          formatted[prefix].push(store);
        } else {
          formatted[prefix] = [store];
        }
      }

      if (compare) {
        let newFormatted = [];
        for (let key in formatted) {
          newFormatted.push({
            name: this.$format("{} ({}/{})", key, formatted[key].length, compare[key].length),
            value: formatted[key]
          });
        }
        // console.log(newFormatted);
        return newFormatted;
      } else {
        return formatted;
      }
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped>

</style>